/**
 * Define em quais rotas o alerta de "nova versão disponível" faz sentido
 * aparecer. O alerta é voltado a usuários dentro da área autenticada do app;
 * em páginas públicas (landing do FastComp, sign-in/sign-up, recuperação de
 * senha etc.) ele é ocultado, embora a detecção de atualização continue
 * rodando normalmente.
 */

export const FASTCOMP_APP_PATH_PREFIX = '/fastcomp/app';

export const LEGACY_PUBLIC_PATHS = [
  '/',
  '/mfa-verification',
  '/userremember',
  '/privacy-policy',
  '/reset-password',
] as const;

/**
 * Retorna `true` quando o alerta de atualização deve ser exibido na rota.
 *
 * - Área autenticada do FastComp (`/fastcomp/app` e filhos) → true
 * - Qualquer outra rota `/fastcomp` (landing, identidade, not-found público) → false
 * - Páginas públicas do app legado → false
 * - Demais rotas (área autenticada do legado) → true
 *
 * Rotas públicas futuras não listadas caem no default `true` (tratadas como
 * área autenticada), por segurança do comportamento atual.
 */
export function shouldShowUpdateAlert(pathname: string): boolean {
  if (
    pathname === FASTCOMP_APP_PATH_PREFIX ||
    pathname.startsWith(`${FASTCOMP_APP_PATH_PREFIX}/`)
  ) {
    return true;
  }

  if (pathname === '/fastcomp' || pathname.startsWith('/fastcomp/')) {
    return false;
  }

  return !LEGACY_PUBLIC_PATHS.includes(pathname as (typeof LEGACY_PUBLIC_PATHS)[number]);
}
